<div
  class="navigation"
  [class.navigation--open]="navigation.open$ | async"
  [class.navigation--left]="(navigation.alignment$ | async) !== 'right'"
  [class.navigation--right]="(navigation.alignment$ | async) === 'right'"
  [class.navigation--overlay]="navigation.overlay$ | async"
  [class.navigation--backdrop-visible]="backdropVisible$ | async"
  [inert]="
    (navigation.open$ | async) !== true &&
    ((navigation.overlay$ | async) || (navigation.mobileView$ | async))
  "
>
  @if ((navigation.alignment$ | async) === 'right') {
    <ng-container *ngTemplateOutlet="subMenu"></ng-container>
  }

  <app-navigation-drawer
    class="navigation__main"
    [narrow]="navigation.narrow$ | async"
    [items]="navigation.navigationItems$ | async"
  >
    <ng-content select="[navigationHeader]" ngProjectAs="header"></ng-content>
    <ng-content select="[navigationFooter]" ngProjectAs="footer"></ng-content>
  </app-navigation-drawer>

  @if ((navigation.alignment$ | async) !== 'right') {
    <ng-container *ngTemplateOutlet="subMenu"></ng-container>
  }

  <ng-template #subMenu>
    <ng-container
      *ngrxLet="
        navigation.floatingSubMenuParentItem$ as floatingSubMenuParentItem
      "
    >
      @if (floatingSubMenuParentItem?.children?.length) {
        <app-navigation-drawer
          class="navigation__sub"
          [items]="floatingSubMenuParentItem.children"
          [isFloatingSubMenu]="true"
        ></app-navigation-drawer>
      }
    </ng-container>
  </ng-template>

  <div
    class="navigation__backdrop"
    [class.navigation__backdrop--visible]="backdropVisible$ | async"
    (click)="onBackdropClick()"
    [@fade]="(backdropVisible$ | async) ? 'show' : 'hide'"
    (@fade.done)="fadeDone($event)"
  ></div>
</div>
